<div class="buttons">
    <rask-button color="secondary" ngbTooltip="Area" (click)="toggle('area')" icon="esri-icon-measure-area"
        [selected]="currentTool === 'area'">
    </rask-button>
    <rask-button color="secondary" ngbTooltip="Avstånd" (click)="toggle('distance')" icon="esri-icon-measure"
        [selected]="currentTool === 'distance'">
    </rask-button>
    <rask-button color="secondary" ngbTooltip="Plats" (click)="toggle('position')" icon="fal fa-map-marker-alt"
        [selected]="currentTool === 'position'">
    </rask-button>
</div>

<div class="options">
    @switch (currentTool) {
    @case ('distance') {
    <rask-selector
        [disabled]="!canChangeUnit"
        class="low col-12"
        [viewFormatter]="viewFormatter"
        (change)="unitChange($event)"
        [(ngModel)]="distanceMultiplier"
        [values]="distanceMultiplierValues">
    </rask-selector>
    }
    @case ('area') {
    <rask-selector
        [disabled]="!canChangeUnit"
        class="low col-12"
        [viewFormatter]="viewFormatter"
        (change)="unitChange($event)"
        [(ngModel)]="areaMultiplier"
        [values]="areaMultiplierValues">
    </rask-selector>
    }
    @case ('position') {
    <rask-selector
        class="low col-12"
        [viewFormatter]="viewFormatter"
        (change)="refreshPosition()"
        [(ngModel)]="positionFormatter"
        [values]="positionFormatterValues">
    </rask-selector>
    }
    }
</div>

@if(currentTool){
<div class="result">
    @if (currentTool !== 'position') {
    <div class="result-measurement">
        <rask-label class="measurement-label" size="12">Mätningsresultat</rask-label>
        @for (result of measurementResults; track result; let i = $index) {
        <div class="row measurement-row">
            <rask-span size="9">
                {{ result.value | number:'1.0-2'}} {{ currentResultUnit }}
            </rask-span>
            <rask-icon-button class="col-2" (click)="deleteMeasure(i)" icon="far fa-trash-alt"
                negative></rask-icon-button>
        </div>
        }
        @if (measurementResult) {
        <div class="row measurement-row">
            <rask-span size="9">
                {{ measurementResult.value | number:'1.0-2'}} {{ currentResultUnit }}
            </rask-span>
            <rask-icon-button class="col-2" (click)="deleteCurrentMeasure()" icon="far fa-trash-alt"
                negative></rask-icon-button>
        </div>
        }
        @if (measurementResults) {
        <div class="row measurement-row">
            <div class="summary-spacer"></div>
            <rask-span size="12" class="measurement-summary">
                {{summary | number:'1.0-2'}} {{ currentResultUnit }}
            </rask-span>
        </div>
        }
        <div class="row measurement-row">
            <rask-button id="new-measure-btn" [disabled]="!measurementResult" color="secondary"
                (click)="newMeasure()">Mät flera</rask-button>
        </div>
    </div>
    }
    @else {
    <div class="result-position">
        <rask-list [data]="positionResult">
            <rask-list-column header="Latitud/N" field="x"></rask-list-column>
            <rask-list-column header="Longitud/E" field="y"></rask-list-column>
        </rask-list>
    </div>
    }
</div>
}